import useSWR from "swr";

export const useCategoryType = (searchQuery, productionId) => {
    let clientsKey;
    if (searchQuery) {
        const params = new URLSearchParams({ searchParams: searchQuery });
        if (productionId) {
            params.append('productionId', productionId.toString());
        }
        clientsKey = `/production-category-type/search-production-category-type?${params.toString()}`;
    } else if (productionId) {
        clientsKey = `/production-category-type?productionId=${productionId}`;
    } else {
        clientsKey = `/production-category-type`;
    }
    
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        category_type: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};